import { cn } from "@pulsex/utils";
import { MangoBlockProps } from "@/types/general";
import Link from "next/link";
import SocialsList from "./DetailsPage/Socials";
import Author from "./Author";
import ImageUI from "./CustomImage/ImageUI";

export default function VideoDetails({ block, ...rest }: MangoBlockProps) {
    const widget = block?.getMainWidget();
    if (!widget || !widget?.posts?.length) return;
    const post = widget.posts[0];
    const videoMedia = post?.findMedia((m) => m.type === "video");
    const [host, guest] = [post?.findMeta((m) => m.key === "host"), post?.findMeta((m) => m.key === "guest")];
    const preparedBy = post?.findMeta((m) => m.key === "preparedby");
    const showDate = "showDate" in (rest as any) ? (rest as any).showDate : true;
    return (
        <section className={cn("container mx-auto my-5")}>
            <h1 className="font-bold text-4xl dark:text-white mt-6 mb-3 lg:text-xl lg:mt-0">
                {post?.title}
            </h1>
            <div className="flex flex-wrap text-sm text-gray-400 opacity-30 dark:text-white mb-3 divide-x divide-gray-400">
                {host && <p>Host: {host.value} &nbsp;</p>}
                {guest && <p>&nbsp; Guest: {guest.value} &nbsp;</p>}
            </div>
            <div className="flex items-center flex-wrap text-sm text-gray-400 dark:text-white mb-2 divide-x divide-gray-400">
                {post?.author?.name && (
                    <Author className="flex items-center gap-1 group" author={post.author}>
                        <div>
                            <ImageUI
                                data={{
                                    image: post.author
                                        ?.icon,
                                }}
                                ImageElementClassName="object-cover inset-0"
                                cropSize={"standard"}
                                className="rounded-full object-cover bg-white dark:bg-darkbg w-12 h-12 lg:w-5 lg:h-5"
                                needsMediaURL={true}
                            />
                        </div>
                        <div>
                            <p
                                className={
                                    "text-sm dark:text-white dark:opacity-100 lg:text-xs group-hover:text-primary"
                                }
                            >
                                {post.author.name} &nbsp;
                            </p>
                        </div>
                    </Author>
                )}
                
                {preparedBy && (
                    <span>
                        &nbsp;Prepared By: {preparedBy.value} &nbsp;
                    </span>
                )}

                {showDate && post.displayDate && <span>&nbsp; {post.displayDate} &nbsp;</span>}
                {post.shares !== null ? <span>&nbsp; {post.shares || 0} Shares</span> : ""}
            </div>
            <p className="italic text-lg dark:text-white mb-2">
                {post?.summary}
            </p>
            <SocialsList post={post}/>
            {/* <ImageUI data={post} cropSize={"rectangle"} /> */}
            <div className="w-full pt-[56.25%] rounded-xl relative overflow-hidden">
            <iframe className="absolute inset-0 w-full h-full" src={videoMedia?.embedUrl}/>
            </div>
            <div className="flex flex-wrap mt-4">
                {post?.keywords.map((k: any, index: any) => (
                    <Link
                        href={`/tags/${k}`}
                        key={index}
                        className="border border-primary rounded-lg px-5 py-1 transition-all mr-4 mt-4 lg:mr-2 lg:mt-2 hover:bg-primary text-black/70 dark:text-white/80 hover:text-white/80"
                    >
                        <span className="text-lg">{k}</span>
                    </Link>
                ))}
            </div>
        </section>
    );
}
